const body = document.querySelector('body')

// nav trigger/mobile nav
const nav = document.querySelector('.main-nav')
const navTrigger = document.querySelector('[data-navtrigger]')

if(navTrigger) {
	navTrigger.addEventListener('click', function(el){
		navTrigger.classList.toggle('active')
		nav.classList.toggle('open')
	})
}


// Natural Error random background
const naturalErrorBody = document.querySelector('.js-natural-error-bg')
if(naturalErrorBody) {
	const bgs = [
		'/images/natural-error/bgs/small/01.gif',
		'/images/natural-error/bgs/small/02.gif',
		'/images/natural-error/bgs/small/03.gif',
		//'/images/natural-error/bgs/small/04.gif',
		//'/images/natural-error/bgs/small/05.gif',
		//'/images/natural-error/bgs/small/06.gif'
	]
	let bg = bgs[Math.floor(Math.random()*bgs.length)]
	naturalErrorBody.setAttribute('style', `background-image:url(${bg})`)
}


// Flashing content warnings
const warningButtons = document.querySelectorAll('.js-content-warning')
const warningModal = document.getElementById('content-warning')

if(warningButtons) {
	// if the cookie is set then hide the content warning
	if(getCookie('allowFlash')){
		if(warningModal){
			warningModal.classList.add('hidden')
		}
	}


	// behaviours
	warningButtons.forEach(el => {
		el.addEventListener('click', function(e) {
			e.preventDefault();
			let action = e.target.dataset.flashconfirm
			console.log(action)
			if(action == 'true') {
				// set the cookie
				setCookie('allowFlash', true, 30)
				console.log('cookie set')
				//warningModal.classList.add('hidden')
				location.reload();
			}

			if(action == 'false') {
				// delete the cookie?
				deleteCookie('allowFlash')
				location.href = e.target.href
			}
		})
	})
}


// cookie functions

function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
}

function setCookie(name, value, days) {
    var d = new Date;
    d.setTime(d.getTime() + 24*60*60*1000*days);
    document.cookie = name + "=" + value + ";path=/;expires=" + d.toGMTString();
}

function deleteCookie(name) { setCookie(name, '', -1); }
